export default __webpack_public_path__ + "static/media/032-padlock.fcd5e98b.svg";